<!--
 Created on Thu Jun 01 2023

 Copyright (c) Cynnox, Inc - All Rights Reserved 2023 Jagan

Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential Written by Jagan <jagancpj246@gmail.com>, September 2020.
-->

<div>
  <div style="box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75)">
    <app-header></app-header>
  </div>

  <div style="overflow-y: scroll; height: calc(100vh - 50px)">
    <div class="container">
      <h1>About Us</h1>
      <p>
        ConnectNow is a product of Kayool Technologies PVT Ltd. A dedicated and
        innovative company aiming to make a ‘next big thing’ in the technology
        which will make an impact in the peoples life. ConnectNow AI helps
        business and customer community to connect each other seamlessly with
        our integrated video call platform. The aim of ConnectNow is to enrich
        the business customer relationship to next level .
      </p>
      <h1>Privacy Policy</h1>
      <p>
        This privacy policy is applicable on usage of ConnectNow or any services
        or features or app related to the Kayool ( “we” or “us” or “our”).
      </p>
      <div>
        <h4>Information We Collect:</h4>
        <p>
          We collect different types of information from you, depending on how
          you interact with our connectNow.ai App. This may include personal and
          Account Information. When you create an account, we may collect your
          name, email address, username, and password.
        </p>
        <div class="ps-4">
          <h5>Contact Information:</h5>
          <p>
            If you contact us for support or provide feedback, we may collect
            your name, email address, and any other information you provide in
            your communication.
          </p>
          <h5>Usage Data:</h5>
          <p>
            We collect information about how you or your customers use the App,
            such as the features you or your customer access such as customer
            chats, calls, inquiries and the time and date usage to provide you
            in your connectNow.ai dashbords and reports to help your business.
            These set of information also may be used to provide a usage based
            billing based on the plan you sign up with us.
          </p>
          <h5>Device Information:</h5>
          <p>
            We may collect information about your customer’s device including
            the device type, operating system, unique device identifiers (such
            as advertising identifiers), IP address, and mobile network
            information.
          </p>
          <h5>Location Data:</h5>
          <p>
            With user’s consent, we may collect precise or approximate location
            data from device. Users can typically control location sharing
            through your device settings.
          </p>
          <h5>Payment Information:</h5>
          <p>
            We may collect your payment information, if you are purchasing our
            product or service directly, such as credit card details or other
            payment method information. Please note that we often use
            third-party payment processors, and we may not directly store your
            full payment details.
          </p>
          <h5>Other Information:</h5>
          <p>Any other information you voluntarily provide to us.</p>
        </div>

        <h4>How We Use Your Information:</h4>
        <p>
          We may use your personal information for various purposes, including
          to:
        </p>
        <div class="ps-3">
          <ol>
            <li>Provide, operate, and maintain the App.</li>
            <li>
              Personalize your experience and provide content tailored to your
              interests.
            </li>
            <li>
              Communicate with you, including responding to your inquiries and
              providing support.
            </li>
            <li>
              Send you updates, notifications, and promotional materials (where
              permitted by law and with your consent where required).
            </li>
            <li>
              Process payments and fulfill transactions (if applicable). Monitor
              and analyze App usage and trends to improve the App's
              functionality and user experience.
            </li>
            <li>
              Other Information: Any other information you voluntarily provide
              to us.
            </li>
          </ol>
        </div>
        <h4>How We manage Your Information:</h4>
        <div class="ps-3">
          <ol>
            <li>
              We use your information to provide you the best service. We will
              not sell your personal information with any third party companies.
              We may share your information to our partners only for certain
              functions such as payment processing gateway or hosting. These
              providers have access to your personal information only to perform
              these tasks on our behalf and are obligated not to disclose or use
              it for other purposes.
            </li>
            <li>
              Legal Authorities: We may disclose your personal information to
              law enforcement agencies, government bodies, or other third
              parties if required by law.
            </li>
            <li>
              Business Transfers: In the event of a merger, acquisition,
              reorganization, sale of assets, or bankruptcy, your personal
              information may be transferred to a successor entity. We will
              notify you of such a transfer and any changes to this Privacy
              Policy.
            </li>
            <li>
              Aggregated and Anonymized Data: We may share aggregated or
              anonymized information that does not directly identify you with
              third parties for various purposes, including analytics and
              research.
            </li>
            <li>
              Data Security: We take reasonable measures to protect your
              personal information from unauthorized access, use, disclosure,
              alteration, or destruction. However, please be aware that no
              method of transmission over the internet or method of electronic
              storage is completely secure, and we cannot guarantee the absolute
              security of your information.
            </li>
          </ol>
        </div>
      </div>

      <h3>Data Privacy</h3>
      <p>
        ConnectNow may collect the following data from the user for its
        functionalities.
      </p>

      <div>
        <app-data-collected></app-data-collected>
      </div>

      &nbsp;
      <h1>Terms of Service</h1>
      &nbsp;
      <h3>User Agreement</h3>
      <p>
        This User Agreement is applicable on usage of ConnectNow or any services
        or features or app related to the ConnectNow ( “we” or “us” or “our” or
        “it” ). User agrees to this agreement while be a user of ConnectNow.
      </p>
      <h3>Changes to the agreement</h3>
      <p>
        Kayool (“we” or “us”) may change this user agreement any time in future.
        If we make any changes, we will communicate to you via our sites,
        service or other means and will provide an opportunity to review it
        before it get into effect. If you don’t agree with the changes, you can
        delete ConnectNow app before the changes go into the effect.
      </p>
      <h3>Disputes and Arguments</h3>
      <p>
        Kayool believes in trust, transparency , integrity and being truthful
        and only conduct lawful and ethical business. If there is any dispute or
        court cases any user or third party may have against us shall be only
        filed within the jurisdiction of Nilambur, Kerala, (India) court or
        police station and all proceedings or decisions of the above said court
        will be final. At any circumstances, any disputes or complaints or cases
        against Kayool shall not be filed outside of the above mentioned court
        jurisdiction.
      </p>
      &nbsp;
    </div>
    <div class="footer mt-4">
      <app-footer></app-footer>
    </div>
  </div>
</div>
